import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { getLocalStorage } from '../../utils/localStorage';
import { raiseTicket, ticketreset } from '../../redux/action/ticketActions';

export const  FormDialog = ({issueMessage,   setIssueMessage, issue, setOpen, open})  => {
   
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { userRedux, status, failedMessage } = useSelector(state => ({
      userRedux: state.userState.user,
      status: state.ticketState.status,
      failedMessage: state.ticketState.failedMessage
    }))
    const user = userRedux || getLocalStorage("user")
    React.useEffect($=>{
        status==="completed" &&  enqueueSnackbar('Ticket raised successfully', { variant : 'success' });
        status==="failed" &&  enqueueSnackbar( failedMessage, { variant : 'error' })
        return () => dispatch(ticketreset());
     }, [status, dispatch, enqueueSnackbar, failedMessage])
  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = e => {
    e.preventDefault();
  
    const payload = {
        user: {
           clientId:  user.clientId
        },
         issue, 
         issueMessage
    }
    dispatch(raiseTicket(payload));
    handleClose()
  }

  return (
    <div>
   
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{issue}</DialogTitle>
        <DialogContent>
          <DialogContentText>
             Please enter your query or issue
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Message"
            required
            multiline
            value={issueMessage}
            onChange={e=> setIssueMessage(e.target.value)}
            id="outlined-start-adornment"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit}>Send</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
